export default "__VITE_ASSET__mUKNTqzq__"